import { snakeCase } from "lodash"
import { theme } from "twin.macro"

export const CAMPAIGN_STATUSES = [
    {
        key: 0,
        label: "Not Scheduled",
        labelColor: theme`colors.red600`,
        bg: theme`colors.red200`,
        color: theme`colors.red600`
    },
    {
        key: 1,
        label: "Pending Approval",
        labelColor: theme`colors.indigo600`,
        bg: theme`colors.indigo200`,
        color: theme`colors.indigo600`
    },
    {
        key: 2,
        label: "Partially Scheduled",
        labelColor: theme`colors.yellow800`,
        bg: theme`colors.yellow200`,
        color: theme`colors.yellow800`
    },
    {
        key: 3,
        label: "Scheduled",
        labelColor: theme`colors.teal600`,
        bg: theme`colors.teal200`,
        color: theme`colors.teal800`
    },
    {
        key: 4,
        label: "Blocked",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    },
    {
        key: -1,
        label: "Error",
        labelColor: theme`colors.red600`,
        bg: theme`colors.red200`,
        color: theme`colors.red600`
    }
]

const CAMPAIGN_STATUS = {}
const CAMPAIGN_STATUS_MAP = {}

for (const config of CAMPAIGN_STATUSES) {
    CAMPAIGN_STATUS_MAP[config.key] = config
    const key = snakeCase(config.label).toUpperCase()
    CAMPAIGN_STATUS[key] = config.key
}

export { CAMPAIGN_STATUS, CAMPAIGN_STATUS_MAP }
